import { createAction } from '@reduxjs/toolkit';

export const setPayload = createAction<any>('setPayload');